/*
 * Keep the displayed promotion price in sync with the selected variant/condition.
 *
 * The server renders the promo for the initial variant. When the shopper switches
 * variant/condition, this recomputes the banner (and sticky-bar) promo price.
 *
 * This theme is customized: it does NOT reliably publish Dawn's `variantChange`
 * pub/sub event, and there's no embedded variant JSON — it just re-renders the
 * `#price-…` block via a section fetch. So instead of listening for that event we:
 *   1) fetch /products/<handle>.js once for an authoritative variant id -> price map,
 *   2) watch the theme's own price element(s) for re-renders (whatever triggers them),
 *   3) read the now-current variant id and recompute every [data-tc-promo] block.
 * No money-string parsing; price comes from Shopify's product JSON (cents).
 */
(function () {
  if (!document.querySelector('[data-tc-promo]')) return;

  function moneyFromCents(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      var fmt = (window.theme && window.theme.moneyFormat) || window.moneyFormat || '${{amount}}';
      return Shopify.formatMoney(cents, fmt);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  // Promo params are identical on every container (same promo, varying base price).
  var first = document.querySelector('[data-tc-promo]');
  var promoType = first.getAttribute('data-promo-type');
  var promoVal = parseFloat(first.getAttribute('data-promo-value')) || 0;

  function applyPrice(priceCents) {
    if (priceCents == null || isNaN(priceCents)) return;
    var savings = promoType === 'percentage'
      ? Math.floor(priceCents * promoVal / 100)
      : Math.round(promoVal * 100);
    var newPrice = Math.max(0, priceCents - savings);
    document.querySelectorAll('[data-tc-promo]').forEach(function (root) {
      var elNew = root.querySelector('[data-promo-new]');
      var elWas = root.querySelector('[data-promo-was]');
      var elSave = root.querySelector('[data-promo-save]');
      if (elNew) elNew.textContent = moneyFromCents(newPrice);
      if (elWas) elWas.textContent = moneyFromCents(priceCents);
      if (elSave) elSave.textContent = 'Save ' + moneyFromCents(savings);
    });
  }

  function currentVariantId() {
    var fromUrl = new URLSearchParams(location.search).get('variant');
    if (fromUrl) return fromUrl;
    var input = document.querySelector('[name="id"]');
    return input ? input.value : null;
  }

  var variantMap = {};
  var lastId = null;
  function recompute() {
    var id = currentVariantId();
    if (!id || id === lastId) return;
    if (variantMap[id] != null) { lastId = id; applyPrice(variantMap[id]); }
  }

  var seg = location.pathname.split('/products/')[1];
  var handle = seg ? seg.split('/')[0].split('?')[0] : null;
  if (!handle) return;

  fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (p) {
      (p.variants || []).forEach(function (v) { variantMap[v.id] = v.price; });
      lastId = currentVariantId();

      // Trigger on the shopper's selection...
      document.addEventListener('change', function (e) {
        if (e.target.closest('variant-selects, variant-radios, .product-form__input, .tc-pdp-condition-cards, fieldset')) {
          setTimeout(recompute, 60);
        }
      });
      // ...and as a backstop, whenever the theme re-renders a price element.
      var priceEls = document.querySelectorAll('[id^="price-"], .tc-price, #tc-stickybuy .tc-stickybuy__price');
      priceEls.forEach(function (el) {
        new MutationObserver(function () { recompute(); })
          .observe(el, { childList: true, subtree: true, characterData: true });
      });
    })
    .catch(function () { /* leave server-rendered price as-is */ });
})();
